module.exports = __webpack_public_path__ + "img/16129835934.SET.14d2a53f.svg";